// extracted by mini-css-extract-plugin
export default {"userManagementRoot":"UserManagementRoot_userManagementRoot__9zngK","breadcrumb-Wrapper":"UserManagementRoot_breadcrumb-Wrapper__tn3bE"};